import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import Icon from '../AppIcon';

const AuthenticationNavigation = () => {
  const location = useLocation();
  const isLogin = location?.pathname === '/login';
  const isRegister = location?.pathname === '/register';

  if (!isLogin && !isRegister) {
    return null;
  }

  return (
    <header className="auth-navigation fixed top-0 left-0 right-0 h-16 bg-card border-b-2 border-primary z-[1000] shadow-glow-cyan-md">
      <div className="h-full px-base flex items-center justify-between max-w-7xl mx-auto">
        <div className="auth-navigation-logo flex items-center gap-md">
          <div className="w-10 h-10 bg-primary/20 rounded-sm flex items-center justify-center border border-primary shadow-glow-cyan-sm transition-all duration-base hover:shadow-glow-cyan-md">
            <Icon name="Zap" size={24} color="var(--color-primary)" />
          </div>
          <span className="text-xl font-heading font-bold neon-text-cyan">
            CyberOddEven
          </span>
        </div>

        <nav className="flex items-center gap-sm">
          <Link
            to="/login"
            className={`
              px-lg py-sm rounded-sm font-caption text-sm tracking-wide
              transition-all duration-base touch-target
              ${isLogin
                ? 'bg-primary/20 text-primary border border-primary shadow-glow-cyan-sm'
                : 'text-foreground hover:text-primary hover:bg-primary/10 border border-transparent'
              }
            `}
          >
            <div className="flex items-center gap-sm">
              <Icon name="LogIn" size={18} />
              <span>Login</span>
            </div>
          </Link>

          <Link
            to="/register"
            className={`
              px-lg py-sm rounded-sm font-caption text-sm tracking-wide
              transition-all duration-base touch-target
              ${isRegister
                ? 'bg-secondary/20 text-secondary border border-secondary shadow-glow-magenta-sm'
                : 'text-foreground hover:text-secondary hover:bg-secondary/10 border border-transparent'
              }
            `}
          >
            <div className="flex items-center gap-sm">
              <Icon name="UserPlus" size={18} />
              <span>Register</span>
            </div>
          </Link>
        </nav>
      </div>
    </header>
  );
};

export default AuthenticationNavigation;